export const formatDate = (date) => {
  if (date) return new Date().toISOString().slice(0, 10).replaceAll('-', '')
  return Date.now().toString().slice(-8)
}
